import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <span className="text-xs font-medium tracking-widest uppercase text-secondary-500 bg-secondary-100 px-3 py-1 rounded-full">
            吃瓜指南
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mt-4">
            吃瓜指南
          </h2>
          <p className="text-sm text-foreground-600 mt-2">关于每日吃瓜，你想知道的都在这里</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqData.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <div className="p-5 md:p-6 flex items-start gap-4">
                <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-sm font-bold text-primary-500">Q</span>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-heading text-base font-bold text-foreground-950 mb-3">
                    {item.question}
                  </h3>
                  <p className="text-sm text-foreground-700 leading-relaxed">{item.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}